import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'
import { func, bool, string } from 'prop-types'
import FormInput from './FormInput'
import FormTextarea from './FormTextarea'

const required = value => value ? undefined : 'Campo obrigatório'

const VideoAdd = ({
  handleSubmit,
  pristine,
  submitting,
  campaignId
}) => (
  <div className='container'>
    <div className='row'>
      <div className='col-md-12'>
        <form className='form-horizontal' onSubmit={handleSubmit}>
          <div className='form-group'>
            <Field
              type='text'
              name='title'
              component={FormInput}
              label='Título:'
              placeholder='título do video'
              validate={required}
            />
          </div>

          <div className='form-group'>
            <Field
              name='description'
              component={FormTextarea}
              label='Descrição:'
              placeholder='breve descrição sobre o video'
              validate={required}
            />
          </div>

          <div className='form-group'>
            <Field
              type='text'
              name='group'
              component={FormInput}
              label='Tags:'
              placeholder='tags,para,o,video'
              validate={required}
            />
          </div>

          <div className='form-group'>
            <div className='col-sm-9 col-sm-offset-2'>
              <div className='pull-right'>
                <Link to={`/campaigns/${campaignId}/videos`} className='btn btn-default'>Voltar</Link>
                <button type='submit' className='btn btn-primary ml10' disabled={submitting}>Salvar</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
)

VideoAdd.propTypes = {
  handleSubmit: func,
  pristine: bool,
  submitting: bool,
  campaignId: string
}

export default reduxForm({ form: 'videoAdd' })(VideoAdd)



// WEBPACK FOOTER //
// ./src/components/VideoAdd.js